<!--
================================================
Un composant permettant de selectionner la période à afficher dans la reportView
LA DIFFÉRENCE AVEC PERIODSELECTORCOMP EST LA POSSIBILITÉ DE SÉLECTIONNER UNE PÉRIODE CUSTOM

La période choisie est transmise via une event 'report_period_changed'.

Url d'accès : http://localhost:8080/fr/cronocloud-inc/reports/summary/startDate=/endDate=/

LIMITATION :
 * si l'on clique sur les boutons .prevNext et que l'on dépasse la plage de calendrier initialement affichée dans le datepicker, le datepicker s'ouvre à la date actuelle et non à la date sélectionnée

================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
  <div id="PeriodSelectorCustomComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}"
       v-click-outside="onClickOutside">

    <div class="columns is-mobile">

      <!--      <div class="column is-8-fullhd is-8-widescreen is-9-desktop-  periodName">-->
      <div class="column is-narrow periodName">
        <div class="currentPeriodName is-flex is-align-items-center">

          <font-awesome-icon :icon="['far', 'calendar-alt']" class="icon"/>
          <date-range-picker v-model="pickerDates"
                             ref="picker"
                             :autoApply="config.autoApply" :opens="config.opens"
                             :locale-data="config.localeData[$i18n.locale]"
                             :showCustomRangeLabel="config.showCustomRangeLabel"
                             :alwaysShowCalendars="config.alwaysShowCalendars"
                             :ranges="config.ranges"
                             :singleDatePicker="config.singleDatePicker"
                             :linkedCalendars="false"
                             :maxDate="config.maxDate"
                             :minDate="config.minDate"
                             @update=""
                             @finishSelection=""
                             @toggle="onToggle($event)"
                             :showDropdowns="config.showDropdowns"
          >
            <template slot="input" slot-scope="input" class="slotInput">

              <div class="slotInput">
                <div class="rangeNameTxt custom">
                      <span class="datesRange" id="periodDatesPreview">

                        {{ $moment(pickerDates.startDate).format('L') }}
                        <span
                            v-if="$moment(pickerDates.startDate).format('L') != $moment(pickerDates.endDate).format('L')">
                           - {{ $moment(pickerDates.endDate).format('L') }}
                        </span>

                        <div v-if="rangeNameI18n != 'custom'" class="exactRangeName">{{ rangeNameI18n }}</div>

                      </span>
                </div>
              </div>

            </template>


          </date-range-picker>

        </div>


      </div>

      <div class="column prevNext is-narrow prev" v-bind:class="{'disabled':index==this.availablePeriods.length-1}"
           id="prevRangeBtn"
           v-on:click="calculatePreviousRange()" v-bind:title="$t('periodePrécédente')">
        <font-awesome-icon class="icon" :icon="['fas', 'caret-left']"/>
      </div>

      <!-- on désactive le bouton suivant si la date de fin du pickr est supérieure à la date du jour -->
      <div v-if="currentRangeEndsAfterToday()" class="column prevNext is-narrow next disabled"
           id="nextRangeBtnDisabled">
        <font-awesome-icon class="icon" :icon="['fas', 'caret-right']"/>
      </div>
      <div v-else class="column prevNext is-narrow next"
           id="nextRangeBtn"
           v-on:click="calculateNextRange()" v-bind:title="$t('periodeSuivante')">
        <font-awesome-icon class="icon" :icon="['fas', 'caret-right']"/>
      </div>

    </div>
  </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
import {mapState} from 'vuex'
// import SentryMixin from "../../mixins/SentryMixin";
// import GlobalErrorNotification from "../../mixins/GlobalErrorNotificationMixin.js";
// import InterceptorMixin from "../../mixins/InterceptorMixin.js";
import _ from "lodash";
import vClickOutside from 'v-click-outside'

import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  name: 'PeriodSelectorCustomComp', //utile dans vue dev tool
  directives: {
    clickOutside: vClickOutside.directive,
  },
  mixins: [
    // GlobalErrorNotification, SentryMixin, InterceptorMixin
  ],
  components: {DateRangePicker},
  filters: {

  },

  data: function () {

    return {
      pickerIsVisible: false, // true si le picker est actuellement ouvert
      pickerDates: { // les dates sélectionnée dans le dateRangePicker
        startDate:
            this.$moment(this.$route.params.startDate), // hydratdation depuis l'url
        endDate:
            this.$moment(this.$route.params.endDate), // hydratdation depuis l'url
      },


      periodNames: // Le nom des périodes (servant à afficher le nom de la période lors de l'ihydratation initiale depuis l'url)
          {
            today: this.$t('Aujourdhui'),
            yesterday: this.$t('Hier'),
            thisWeek: this.$t('CetteSemaine'),
            lastWeek: this.$t('laSemaineDernière'),
            thisMonth: this.$t('CeMoisCi'),
            lastMonth: this.$t('LeMoisDernier'),
            thisYear: this.$t('CetteAnnée'),
            lastYear: this.$t('AnnéeDernière'),
          },

      /** Config du daterangepicker :
       * https://innologica.github.io/vue2-daterange-picker/#props
       * http://www.daterangepicker.com/#config
       **/
      config: {
        autoApply: true, // si true le datepicker valide automatiquement la sélection  (sans besoin de cliquer sur le bouton de validation)
        opens: 'right', // position d'ouverture
        showCustomRangeLabel: true, //
        alwaysShowCalendars: true, // si vaut false le calendrier n'est pas systématiquement affiché à moins que l'on clique au préalable sur 'plage personalisée'
        singleDatePicker: false, // pour afficher seulement 1 mois mettre à true (mobile)
        maxDate: this.$moment().add(1, 'years').toDate(),
        minDate: this.$moment().subtract(20, 'years').toDate(),
        showDropdowns: true, // active les listes déroulantes sur les mois / années
        // dateFormat: this.config.localeData:

        localeData: {
          'en': {
            direction: 'ltr',
            format: 'mm/dd/yyyy',
            separator: ' - ',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            firstDay: 0
          },
          'fr': {
            direction: 'ltr',
            format: 'dd/mm/yyyy',
            separator: ' - ',
            applyLabel: 'Valider',
            cancelLabel: 'Annuler',
            weekLabel: 'S',
            customRangeLabel: 'Plage personnalisée',
            daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
            monthNames: ['Jan.', 'Fév.', 'Mar.', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sep.', 'Oct.', 'Nov.', 'Déc.'],
            firstDay: 1
          }
        },

        ranges: { // défini des plages de dates , la clé est le nom de la période, la valeur contient un array[date début/date fin période]
          [this.$t('Aujourdhui')]: [this.$moment().toDate(), this.$moment().toDate()],
          [this.$t('Hier')]: [this.$moment().subtract(1, 'days').toDate(), this.$moment().subtract(1, 'days').toDate()],
          [this.$t('CetteSemaine')]: [this.$moment().startOf('week').toDate(), this.$moment().endOf('week').toDate()], //@todo define period
          [this.$t('laSemaineDernière')]: [this.$moment().subtract(1, 'week').startOf('week').toDate(), this.$moment().subtract(1, 'week').endOf('week').toDate()],

          [this.$t('CeMoisCi')]: [this.$moment().startOf('month').toDate(), this.$moment().endOf('month').toDate()],
          [this.$t('LeMoisDernier')]: [this.$moment().subtract(1, 'month').startOf('month').toDate(), this.$moment().subtract(1, 'month').endOf('month').toDate()],
          [this.$t('CetteAnnée')]: [this.$moment().startOf('year').toDate(), this.$moment().endOf('year').toDate()], //@todo define period
          [this.$t('AnnéeDernière')]: [this.$moment().subtract(1, 'years').startOf('year').toDate(), this.$moment().subtract(1, 'years').endOf('year').toDate()],

          // [this.$t('7DerniersJours')]: [this.$moment().subtract(6, 'days').toDate(), this.$moment().toDate()],
          // [this.$t('30DerniersJours')]: [this.$moment().subtract(29, 'days').toDate(), this.$moment().toDate()]
        },


      },


      index: 0 // l'index à afficher dans availablePeriods
      , availablePeriods: // un tableau de nom des période à afficher
          [
            'today',
            'yesterday',
            'thisWeek',
            'lastWeek',
            'thisMonth',
            'lastMonth',
            'thisYear',
            'lastYear',
          ],

      // =================================================================
    }
  },

  computed: {
    // computed props for store :
    ...mapState({
      currentPeriod: state => state.ReportView.currentPeriod,
      themeToDisplay: state => state.app.themeToDisplay
    }),

    //----------------------------------------------

    // other computed props :

    rangeNameI18n: { //String | le nom de la période actuellement sélectionnée dans le daterangepicker (si elle est trouvée dans config.ranges sinon vaut custom). Peut-être afficher à l'urilisateur car localisée
      get: function () {
        return this.retrieveRangeName(
            this.$moment(this.$route.params.startDate).format('YYYY-MM-DD'),
            this.$moment(this.$route.params.endDate).format('YYYY-MM-DD')
        )
      },
      set: function () {
      }
    }


  },
  watch: {

    pickerDates: function () {

      // maj des params d'url
      this.$router.push({
        params: {
          startDate: this.$moment(this.pickerDates.startDate).format('Y-MM-DD'),
          endDate: this.$moment(this.pickerDates.endDate).format('Y-MM-DD')
        },
        query: {...this.$route.query}
      })

      this.emitRange()
    },

  },


  methods: {

    /**
     * Retourne true si la date de fin de la période actuelle se termine après la date du jour
     * (Permet de désactiver le bouton #nextRangeBtn)
     **/
    currentRangeEndsAfterToday() {
      if (this.$moment(this.pickerDates.endDate).isAfter(this.$moment())) {
        return true
      }
    },


    /**
     * Met à jour les paramètres d'url quand les dates du picker changent
     **/
    updateUrlWhenDatesChange() {

      // maj des params d'url
      this.$router.push({
        params: {
          // periodName: periodToUpdate,
          startDate: this.$moment(this.pickerDates.startDate).format('YYYY-MM-DD'),
          endDate: this.$moment(this.pickerDates.endDate).format('YYYY-MM-DD')
        },
        query: {...this.$route.query}  // conserve les qs existant

      })

      this.emitRange()
    },

    /**
     * Affiche/masque le daterangepicker de façon programatique
     *  déclenchée quand la visibilité du daterangepicker change
     * basé sur l'event toggle https://innologica.github.io/vue2-daterange-picker/#events
     **/
    onToggle(event) {
      this.$refs.picker.togglePicker(event)
    },


    /**
     * Déclenche en event envoyant la période sélectionnée
     **/
    emitRange() {
      this.$root.$emit('report_period_changed', {
        startDate: this.pickerDates.startDate,
        endDate: this.pickerDates.endDate
      })

    },

    /**
     * En fonction de la période actuelle, calcule la période précédente (de même durée que la période actuelle)
     **/
    calculatePreviousRange() {
      let periodLength = this.calculatePeriodLength(this.$moment(this.pickerDates.startDate), this.$moment(this.pickerDates.endDate))

      // DÉCALAGE DE LA PÉRIODE

      // si taille de l apériode de type jour
      if (periodLength == 1) {
        this.pickerDates.startDate = this.$moment(this.pickerDates.startDate).subtract(1, 'days').toDate()
        this.pickerDates.endDate = this.$moment(this.pickerDates.endDate).subtract(1, 'days').toDate()
      }
      // si taille de l apériode de type semaine
      else if (periodLength == 7) {
        this.pickerDates.startDate = this.$moment(this.pickerDates.startDate).subtract(1, 'weeks').startOf('week').toDate()
        this.pickerDates.endDate = this.$moment(this.pickerDates.endDate).subtract(1, 'weeks').endOf('week').toDate()
      }
      // si taille de l apériode de type mois
      else if (periodLength >= 27 && periodLength <= 31) {
        this.pickerDates.startDate = this.$moment(this.pickerDates.startDate).subtract(1, 'months').startOf('month').toDate()
        this.pickerDates.endDate = this.$moment(this.pickerDates.endDate).subtract(1, 'month').endOf('month').toDate()
      }
      // si taille de l apériode de type année
      else if (periodLength == 365 || periodLength == 366) {
        this.pickerDates.startDate = this.$moment(this.pickerDates.startDate).subtract(1, 'years').toDate()
        this.pickerDates.endDate = this.$moment(this.pickerDates.endDate).subtract(1, 'years').toDate()
      } else { // sinon les autres taille de période (custom)
        this.pickerDates.startDate = this.$moment(this.pickerDates.startDate).subtract(periodLength + 1, 'days').toDate()
        this.pickerDates.endDate = this.$moment(this.pickerDates.endDate).subtract(periodLength + 1, 'days').toDate()
      }

      this.updateUrlWhenDatesChange()
      this.emitRange()

    },


    /**
     * En fonction de la période actuelle, calcule la période suivante (de même durée que la période actuelle)
     **/
    calculateNextRange() {
      if (!this.currentRangeEndsAfterToday()) { // on ne calcule pas de plage suivante si la date du jour est déjà dépassé dans la période actuelle

        let periodLength = this.calculatePeriodLength(this.$moment(this.pickerDates.startDate), this.$moment(this.pickerDates.endDate))

        // DÉCALAGE DE LA PÉRIODE
        // si taille de l apériode de type jour
        if (periodLength == 1) {
          this.pickerDates.startDate = this.$moment(this.pickerDates.startDate).add(1, 'days').toDate()
          this.pickerDates.endDate = this.$moment(this.pickerDates.endDate).add(1, 'days').toDate()
        }
        // si taille de l apériode de type semaine
        else if (periodLength == 7) {
          this.pickerDates.startDate = this.$moment(this.pickerDates.startDate).add(1, 'weeks').startOf('week').toDate()
          this.pickerDates.endDate = this.$moment(this.pickerDates.endDate).add(1, 'weeks').endOf('week').toDate()
        }
        // si taille de l apériode de type mois
        else if (periodLength >= 27 && periodLength <= 31) {
          this.pickerDates.startDate = this.$moment(this.pickerDates.startDate).add(1, 'months').startOf('month').toDate()
          this.pickerDates.endDate = this.$moment(this.pickerDates.endDate).add(1, 'month').endOf('month').toDate()
        }
        // si taille de l apériode de type année
        else if (periodLength == 365 || periodLength == 366) {
          this.pickerDates.startDate = this.$moment(this.pickerDates.startDate).add(1, 'years').toDate()
          this.pickerDates.endDate = this.$moment(this.pickerDates.endDate).add(1, 'years').toDate()
        } else { // sinon les autres taille de période (custom)
          this.pickerDates.startDate = this.$moment(this.pickerDates.startDate).add(periodLength + 1, 'days').toDate()
          this.pickerDates.endDate = this.$moment(this.pickerDates.endDate).add(periodLength + 1, 'days').toDate()
        }


      }

      this.updateUrlWhenDatesChange()
      this.emitRange()


    },

    /**
     * Calcule la durée d'une période en jours ayant pour dates de début/fni startDate & endDatea
     * @param startDate | object moment
     * @param endDate | object moment
     **/
    calculatePeriodLength(startDate, endDate) {
      return endDate.diff(startDate, 'days') + 1  // https://stackoverflow.com/a/9130040/666416
    },


    /* Masque le comp lorsque l'on clique en dehors*/
    onClickOutside(event) {
    },


    /**
     * En fonction des dates passés en paramètre compare les valeurs avec this.config.ranges pour retrouver le nom de la période
     *
     * (vue-daterange-picker ne permet pas de récupérer directement le nom de la période, il faut donc comparer les dates https://github.com/Innologica/vue2-daterange-picker/issues/164)
     *
     * @param startDate Date de début de la période au format YYYY-MM-DD
     * @param endDate Date de fin de la période au format YYYY-MM-DD
     */
    retrieveRangeName(startDate, endDate) {

      let $i = 0;
      let match = null
      let self = this
      _.forEach(this.config.ranges, function (value, key) {
        $i++

        if (startDate == self.$moment(value[0]).format('YYYY-MM-DD') && endDate == self.$moment(value[1]).format('YYYY-MM-DD')) {
          match = key  // key contient le nom de la période
        }
      })

      if (match != null) {
        return match
      } else {
        return 'custom' //si aucune période n'est trouvée alors la prériode est 'custom'
      }

    },


  },

  // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
  mounted: function () {

      // on hydrate le picker avec les dates de l'url
      this.pickerDates.startDate = this.$moment(this.$route.params.startDate)
      this.pickerDates.endDate = this.$moment(this.$route.params.endDate)

      // définition de la plage initialement visible :
      this.pickerDates.startDate = this.$moment(this.$route.params.startDate)
      this.pickerDates.endDate = this.$moment(this.$route.params.endDate)

  }
}
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/css/globalVar.scss";
@import "../../assets/css/bulmaResponsiveDep.scss";


#PeriodSelectorCustomComp {
  position: relative;

  $borderRadiusInner: 3px;


  .periodName {

    $size: 3rem;
    background: white;
    border: solid 1px #ddd;
    margin: 0;
    cursor: pointer;
    font-size: 0.9rem;
    line-height: $size - .1rem;
    height: $size;
    padding: 0;
    border-top-left-radius: $borderRadiusInner;
    border-bottom-left-radius: $borderRadiusInner;

    @include mobile {
      height: auto;
    }

    &:first-letter {
      text-transform: uppercase;
    }

    &.custom {
    }

    .currentPeriodName {
      padding: 0 .9rem;

      .icon {
        color: $brandFourth;
        margin: 0 .3rem 0 0;
        vertical-align: middle;
      }
    }

    .slotInput {

      .rangeNameTxt {

        padding: 0 1rem !important;
        background: transparent !important;
        @include touch {
          padding: 0 !important;
        }

        .exactRangeName {
          color: #fff;
          font-size: .7rem;
          line-height: 1.3rem;
          background-color: $brandFourth;
          border-radius: 4px;
          margin: 0;
          padding: .1rem 0.6rem !important;
          position: absolute;
          top: -1rem;
          right: -0.5rem;
        }

        .datesRange {
          color: $brandThird;
          margin-left: .3rem;
          font-weight: bold;
        }
      }
    }


  }

  .prevNext {
    cursor: pointer;
    $size: 3rem;
    width: $size;
    height: $size;
    color: $brandSecondary;
    background: white;
    border: solid 1px #ddd;

    &.disabled {
      transition: color 200ms ease-out;
      color: $brandFourth;
      cursor: default;
    }

    &.next {
      border-radius: 0 3px 3px 0;
    }

    &.prev {
    }

    .icon {
      font-size: 2.5rem;
    }


  }

  //////////////////////////////////////
  // DARK UI ///////////////////////////
  &.darkMode {

    .rangeNameTxt {

      .datesRange {
        color: $darkContrastTxt !important;
      }
    }

    .periodName {
      background-color:$darkFiltersBg !important;
      color: $darkContrastTxt;
      border-color: lighten($darkBg2, 5%);

      .currentPeriodName {
        .icon {
          color: $darkLightBlue;
        }
      }


    }

    .prevNext {
      background-color: $darkFiltersBg !important;
      color: $darkLightBlue;

      border-color: lighten($darkBg2, 7%);

      &.disabled {
        color: lighten($darkBg, 5%);
      }

    }

  }
}

</style>

<style lang="scss">
// css non scoppé ! surcharge d'autre composants

#PeriodSelectorCustomComp {
  @import "../../assets/css/globalVar.scss";
  @import "../../assets/css/bulmaResponsiveDep.scss";

  // surcharge du datarange picker généré par vue2-daterange-picker
  .reportrange-text {
    border: none !important;
    padding: 0 !important;
    background-color: transparent !important;
  }

  //////////////////////////////////////
  // DARK UI ///////////////////////////
  &.darkMode {

    //surcharge des styles pour adaptés un thème sombre
    // (inspiré de https://gist.github.com/henull/f2beec6095e4329a400abd95f95c21fa)
    .vue-daterange-picker {
      .daterangepicker td.off, .daterangepicker td.off.in-range, .daterangepicker td.off.start-date, .daterangepicker td.off.end-date {
        background-color: transparent;
        color: rgba(200, 200, 200, 0.5);
      }

      .daterangepicker:after {
        border-bottom-color: $darkBg; // couleur de la pointe d'ouverture (configurée via prop "open")
      }

      .daterangepicker {
        background-color: $darkBg;
        border-color: lighten($darkBg, 10%);
        color: #ebf4f0;

        .calendar-table {
          background-color: $darkBg;
          border-color: transparent !important;
        }

        .drp-calendar.left {
          border-color: lighten($darkBg, 10%) !important;
        }

        table {
          th {
            background-color: $darkBg3 !important;
            color: $darkContrastTxt;
            border-radius: 0 !important;
          }


          th.prev, th.next, {
            span { // couleur des icone prev next dans la zone de changement des mois/années
              border-color: $darkTxt;
            }
          }

          td {
            background-color: $darkBg2 !important;
          }

          td.active, td.active:hover {
            background-color: transparent;
            color: #ebf4f8;
          }

          td.in-range {
            // la plage de dates sélectionnée
            background-color: darken($darkLightBlue, 20%) !important;
            color: #ebf4f8;
          }

          td.start-date, td.end-date {
            // les dates de début/fin dans la plage sélectionnée
            background-color: darken($darkLightBlue, 10%) !important;
            color: #ebf4f8;
          }

          .btn-success.disabled, .btn-success[disabled], fieldset[disabled] .btn-success, .btn-success.disabled:hover, .btn-success[disabled]:hover, fieldset[disabled] .btn-success:hover, .btn-success.disabled:focus, .btn-success[disabled]:focus, fieldset[disabled] .btn-success:focus, .btn-success.disabled.focus, .btn-success[disabled].focus, fieldset[disabled] .btn-success.focus, .btn-success.disabled:active, .btn-success[disabled]:active, fieldset[disabled] .btn-success:active, .btn-success.disabled.active, .btn-success[disabled].active, fieldset[disabled] .btn-success.active {
            color: #fff;
            background-color: inherit;
            border-color: rgba(5, 150, 1, 0.1);
          }

          .btn-default {
            color: #fff;
            background-color: inherit;
            border-color: rgba(255, 255, 255, 0.6);
          }

          select.monthselect {
            color: $darkContrastTxt;
            background-color: transparent;
          }

          .yearselect {
            color: $darkContrastTxt;
            background-color: transparent;
          }

          .input-mini {
            color: #ebf4f8;
          }

        }

      }

      .btn-success.disabled, .btn-success[disabled], fieldset[disabled] .btn-success, .btn-success.disabled:hover, .btn-success[disabled]:hover, fieldset[disabled] .btn-success:hover, .btn-success.disabled:focus, .btn-success[disabled]:focus, fieldset[disabled] .btn-success:focus, .btn-success.disabled.focus, .btn-success[disabled].focus, fieldset[disabled] .btn-success.focus, .btn-success.disabled:active, .btn-success[disabled]:active, fieldset[disabled] .btn-success:active, .btn-success.disabled.active, .btn-success[disabled].active, fieldset[disabled] .btn-success.active {
        color: #fff;
        background-color: inherit;
        border-color: rgba(5, 150, 1, 0.1);
      }


      .calendars {
        .ranges {
          li {
            &:hover {
              background-color: darken($darkBg, 5%);
              color: $darkContrastTxt;
            }

            &.active {
              background-color: $brandBlue;
            }
          }
        }
      }
    }
  }
}


</style>
